import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import config from "../config/config";
import { Button, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../redux/slicess/userDataSlice";

const Dashboardheader = () => {
  const dispatch = useDispatch();
  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
      Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
    );
  const [lastparturl, setlastparturl] = useState([]);
  useEffect(() => {
    dynamicLink();

    if (!loginData.id) {
      window.location.href = `${config.baseUrl}`;
    }
  }, []);


  useEffect(() => {
    dispatch(getUserData());
  }, []);

  const userdata = useSelector((state) => state.userData.userData);

  const dynamicLink = () => {
    let url = window.location.href;
    const parts = url.split("/");
    const lastPart = parts[parts.length - 1];
    const secondLastPart = parts[parts.length - 2];

    if (secondLastPart === "nftdetail") {
      setlastparturl("nftdetail"); // Set this as a "base" for dynamic URLs
    } else {
      setlastparturl(lastPart);
    }
  };
  const { pathname } = useLocation();

  const scrollContainerRef = useRef(null);
  // Check if the content overflows
  useEffect(() => {
    const checkOverflow = () => {
      if (scrollContainerRef.current) {
        const isContentOverflowing =
          scrollContainerRef.current.scrollWidth >
          scrollContainerRef.current.clientWidth;
        setIsOverflow(isContentOverflowing);
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  const activeTabRef = useRef(null);

  const [isOverflow, setIsOverflow] = useState(false);

  // Check if content overflows
  useEffect(() => {
    const checkOverflow = () => {
      if (scrollContainerRef.current) {
        const isContentOverflowing =
          scrollContainerRef.current.scrollWidth >
          scrollContainerRef.current.clientWidth;
        setIsOverflow(isContentOverflowing);
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  // Center the active tab on load
  useEffect(() => {
    if (activeTabRef.current && scrollContainerRef.current) {
      scrollToCenter(activeTabRef.current);
    }
  }, [pathname]);

  const scrollToCenter = (tabElement) => {
    const container = scrollContainerRef.current;
    if (!tabElement || !container) return;

    const containerWidth = container.clientWidth;
    const tabLeft = tabElement.offsetLeft;
    const tabWidth = tabElement.clientWidth;

    // Scroll so that the active tab is centered
    const scrollPosition = tabLeft - (containerWidth / 2 - tabWidth / 2);
    container.scrollTo({ left: scrollPosition, behavior: "smooth" });
  };

  const scrollLeftFunc = () => {
    scrollContainerRef.current.scrollBy({ left: -100, behavior: "smooth" });
  };

  const scrollRightFunc = () => {
    scrollContainerRef.current.scrollBy({ left: 100, behavior: "smooth" });
  };

  const checkOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsOverflow(container.scrollWidth > container.clientWidth);
    }
  };
  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  return (
    <>
      <div className="tabs">
        <Container>
          <div className="position-relative mt-2" >
            {isOverflow && (
              <Button
                className="scroll-arrow left-arrow h-auto rounded-5 dashboard-left"
                style={{ backgroundColor: "transparent", color: "white" }}
                onClick={scrollLeftFunc}
              >
                <FaChevronLeft />
              </Button>
            )}

            {/* {console.log('pathname', pathname)} */}


            <div className="scroll-container" ref={scrollContainerRef}>
              <div className="scroll-button">
                <div
                  className={`scrl ${pathname === "/stepmint/dashboard" ? "active" : ""
                    }`}
                  ref={pathname === "/stepmint/dashboard" ? activeTabRef : null}
                >
                  <Link
                    to={`${config.baseUrl}dashboard`}
                    className={`${pathname === "/stepmint/dashboard" ? "active" : ""
                      } custom-link`}
                  >
                    Dashboard
                  </Link>
                </div>
              </div>

              {/* <div className="scroll-button">
                <div
                  className={`scrl ${pathname === "/stepmint/nftbox" ? "active" : ""
                    }`}
                  ref={pathname === "/stepmint/nftbox" ? activeTabRef : null}
                >
                  <Link
                    to={`${config.baseUrl}nftbox`}
                    className={`${pathname === "/stepmint/nftbox" ? "active" : ""} custom-link`}
                  >
                    NFT Box
                  </Link>
                </div>
              </div> */}

              <div className="scroll-button">
                <div
                  className={`scrl ${pathname === "/stepmint/useractivity" ? "active" : ""
                    }`}
                  ref={pathname === "/useractivity" ? activeTabRef : null}
                >
                  <Link
                    to={`${config.baseUrl}useractivity`}
                    className={`${pathname === "/stepmint/useractivity" ? "active" : ""
                      } custom-link`}
                  >
                    User Activity
                  </Link>
                </div>
              </div>

              <div className="scroll-button">
                <div
                  className={`scrl ${pathname === "/stepmint/referral" ? "active" : ""}`}
                  ref={pathname === "/referral" ? activeTabRef : null}
                >
                  <Link
                    to={`${config.baseUrl}referral`}
                    className={`${pathname === "/stepmint/referral" ? "active" : ""
                      } custom-link`}
                  >
                    Referral Reward
                  </Link>
                </div>
              </div>

              <div className="scroll-button">
                <div
                  className={`scrl ${pathname === "/stepmint/matchingbonus" ? "active" : ""
                    }`}
                  ref={pathname === "/matchingbonus" ? activeTabRef : null}
                >
                  <Link
                    to={`${config.baseUrl}matchingbonus`}
                    className={`${pathname === "/stepmint/matchingbonus" ? "active" : ""
                      } custom-link`}
                  >
                    Community Reward
                  </Link>
                </div>
              </div>
              <div className="scroll-button">
                <div
                  className={`scrl ${pathname === "/stepmint/wallethistory" ? "active" : ""
                    }`}
                  ref={pathname === "/wallethistory" ? activeTabRef : null}
                >
                  <Link
                    to={`${config.baseUrl}wallethistory`}
                    className={`${pathname === "/stepmint/wallethistory" ? "active" : ""
                      } custom-link`}
                  >
                    Wallet
                  </Link>
                </div>
              </div>

              <div className="scroll-button">
                <div
                  className={`scrl ${pathname === "/stepmint/staking" ? "active" : ""
                    }`}
                  ref={pathname === "/staking" ? activeTabRef : null}
                >
                  <Link
                    to={`${config.baseUrl}staking`}
                    className={`${pathname === "/stepmint/staking" ? "active" : ""
                      } custom-link`}
                  >
                    Staking
                  </Link>
                </div>
              </div>
              {/* {userdata.rank_id > 4 &&
                <div className="scroll-button">
                  <div
                    className={`scrl ${pathname === "/stepmint/business-proposal" ? "active" : ""
                      }`}
                    ref={pathname === "/business-proposal" ? activeTabRef : null}
                  >
                    <Link
                      to={`${config.baseUrl}business-proposal`}
                      className={`${pathname === "/stepmint/business-proposal" ? "active" : ""
                        } custom-link`}
                    >
                      Proposal
                    </Link>
                  </div>
                </div>
              } */}

            </div>

            {isOverflow && (
              <Button
                className="scroll-arrow right-arrow h-auto rounded-5 dashboard-left"
                style={{ backgroundColor: "transparent", color: "white" }}
                onClick={scrollRightFunc}
              >
                <FaChevronRight />
              </Button>
            )}
          </div>
        </Container>
      </div>
    </>
  );
};
export default Dashboardheader;
